/*
  Artonis — o chon co tim kiem.

  Dung lai dung cach index.artonis.io lam (src/components/FilterDropdown.tsx),
  viet bang JavaScript thuan de chay trong theme Shopify. Muc dich: hai san pham
  cung thuong hieu thi thao tac phai giong nhau.

  Quy uoc lay tu ben do: chi hien o tim khi danh sach tu 10 muc tro len.

  Dung:
    ArtonisFilter.create({
      mount:   phan tu chua,
      label:   'Dia diem',
      allLabel:'Tat ca dia diem',
      options: [{ value, label, count }],
      value:   '',
      onChange: function (value) { ... }
    });
*/
(function () {
  var SEARCH_THRESHOLD = 10;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function plain(s) {
    return (s || '').toLowerCase().replace(/đ/g, 'd')
      .normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function create(cfg) {
    var mount = cfg.mount;
    if (!mount) return null;

    var value = cfg.value || '';
    var options = cfg.options || [];
    var searchable = options.length >= SEARCH_THRESHOLD;
    var open = false;

    mount.classList.add('axf');
    mount.innerHTML = '';

    var btn = el('button', 'axf__btn');
    btn.type = 'button';
    btn.setAttribute('aria-haspopup', 'listbox');
    var btnText = el('span', 'axf__btn-text');
    btn.appendChild(btnText);

    // mui ten mo/dong
    var caret = el('span', 'axf__caret');
    caret.innerHTML =
      '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">' +
      '<path d="M2 4 L5 7 L8 4" stroke="currentColor" stroke-width="1.5" fill="none" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.appendChild(caret);

    // nut xoa (X): chi tao khi cho phep xoa; hien khi dang co lua chon, thay cho caret.
    // Bam vao day chi xoa lua chon, KHONG mo dropdown (stopPropagation).
    var clearEl = null;
    if (cfg.allowClear !== false) {
      clearEl = el('span', 'axf__clear');
      clearEl.setAttribute('role', 'button');
      clearEl.setAttribute('tabindex', '0');
      clearEl.setAttribute('aria-label', cfg.clearLabel || 'Xóa lọc');
      clearEl.hidden = true;
      clearEl.innerHTML =
        '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">' +
        '<path d="M2 2 L8 8 M8 2 L2 8" stroke="currentColor" stroke-width="1.6" ' +
        'stroke-linecap="round"/></svg>';
      clearEl.addEventListener('click', function (ev) {
        ev.stopPropagation();
        ev.preventDefault();
        pick('');
      });
      clearEl.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.stopPropagation();
          ev.preventDefault();
          pick('');
        }
      });
      btn.appendChild(clearEl);
    }
    mount.appendChild(btn);

    var panel = el('div', 'axf__panel');
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    var searchWrap = null, searchInput = null;
    if (searchable) {
      searchWrap = el('div', 'axf__search');
      searchInput = el('input', 'axf__search-input');
      searchInput.type = 'text';
      searchInput.placeholder = cfg.searchPlaceholder || 'Tìm...';
      searchInput.autocomplete = 'off';
      searchWrap.appendChild(searchInput);
      panel.appendChild(searchWrap);
    }
    var list = el('div', 'axf__list');
    panel.appendChild(list);
    mount.appendChild(panel);

    function activeOption() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === value) return options[i];
      }
      return null;
    }

    function renderButton() {
      var a = activeOption();
      btnText.innerHTML = '';
      btnText.appendChild(el('span', 'axf__label', cfg.label));
      if (a) {
        btnText.appendChild(el('span', 'axf__value', ': ' + a.label));
      }
      // O sap xep luon co gia tri nen KHONG to cam — mau cam danh rieng cho
      // "dang co bo loc", de nguoi dung nhin ra ngay cho nao dang lam hep ket qua.
      var on = !!a && cfg.allowClear !== false;
      mount.classList.toggle('is-active', on);
      // dang loc -> hien X de xoa; chua loc -> hien caret de mo
      if (clearEl) clearEl.hidden = !on;
      caret.hidden = on;
    }

    function renderList(query) {
      list.innerHTML = '';
      var q = plain(query || '');
      var shown = options.filter(function (o) {
        return !q || plain(o.label).indexOf(q) !== -1;
      });

      // allowClear === false: khong co dong "Tat ca" — dung cho o Sap xep,
      // vi sap xep luon phai co mot lua chon, khong the "khong chon gi".
      if (!q && cfg.allowClear !== false) {
        var allRow = el('button', 'axf__opt' + (value ? '' : ' is-selected'),
          cfg.allLabel + (cfg.allCount != null ? ' (' + cfg.allCount + ')' : ''));
        allRow.type = 'button';
        allRow.setAttribute('role', 'option');
        allRow.setAttribute('aria-selected', value ? 'false' : 'true');
        allRow.addEventListener('click', function () { pick(''); });
        list.appendChild(allRow);
      }

      shown.forEach(function (o) {
        var row = el('button', 'axf__opt' + (o.value === value ? ' is-selected' : ''),
          o.label + (o.count != null ? ' (' + o.count + ')' : ''));
        row.type = 'button';
        row.setAttribute('role', 'option');
        row.setAttribute('aria-selected', o.value === value ? 'true' : 'false');
        row.addEventListener('click', function () { pick(o.value); });
        list.appendChild(row);
      });

      if (q && !shown.length) {
        list.appendChild(el('div', 'axf__empty', cfg.noResultLabel || 'Không tìm thấy'));
      }
    }

    function pick(v) {
      value = v;
      renderButton();
      setOpen(false);
      if (cfg.onChange) cfg.onChange(v);
    }

    function onDocDown(ev) {
      if (!mount.contains(ev.target)) setOpen(false);
    }

    function setOpen(v) {
      open = v;
      panel.hidden = !v;
      mount.classList.toggle('is-open', v);
      btn.setAttribute('aria-expanded', v ? 'true' : 'false');
      if (v) {
        if (searchInput) { searchInput.value = ''; }   // moi lan mo la xoa o tim
        renderList('');
        document.addEventListener('mousedown', onDocDown);
        if (searchInput) searchInput.focus();
      } else {
        document.removeEventListener('mousedown', onDocDown);
      }
    }

    btn.addEventListener('click', function () { setOpen(!open); });
    if (searchInput) {
      searchInput.addEventListener('input', function () { renderList(searchInput.value); });
    }
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && open) setOpen(false);
    });

    renderButton();

    return {
      get value() { return value; },
      set: function (v) { value = v; renderButton(); },
      update: function (nextOptions, allCount) {
        options = nextOptions || [];
        if (allCount != null) cfg.allCount = allCount;
        searchable = options.length >= SEARCH_THRESHOLD;
        if (searchWrap) searchWrap.hidden = !searchable;
        // gia tri dang chon khong con trong danh sach -> tra ve "Tat ca"
        if (value && !activeOption()) value = '';
        renderButton();
        if (open) renderList(searchInput ? searchInput.value : '');
      },
      setHidden: function (h) { mount.hidden = !!h; },
    };
  }

  window.ArtonisFilter = { create: create };
})();
